import { DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DATEPIPE_DATETIME_FORMAT, DATEPIPE_DATE_FORMAT } from '../../../services/language.service';

@Component({
  selector: 'formatDataValue',
  templateUrl: 'formatDataValue.template.html',
  providers: [DecimalPipe]
})
export class FormatDataValueComponent {
  public DATEPIPE_DATE_FORMAT = DATEPIPE_DATE_FORMAT;
  public DATEPIPE_DATETIME_FORMAT = DATEPIPE_DATETIME_FORMAT;

  @Input()
  value: any;
  @Input()
  type: string;
  @Input()
  valueClassObject: string;
  @Input()
  maxDecimals: number;
  constructor(protected decimalService: DecimalPipe) {
    if (!this.maxDecimals || this.maxDecimals === undefined) {
      this.maxDecimals = 2;
    }

  }


  public getCssClass(): string {
    let cssClass = this.type;
    if (this.valueClassObject) {
      cssClass += ' ' + this.valueClassObject;
    }
    return cssClass;
  }


  public objectToString(obj): string {
    let ret = '';

    if (obj) {
      ret = obj;
      // Si es de tipo Master Data, se devuelve la descripción
      if (obj.identifier && obj.identifier.indexOf('<>') != -1) {
        if (obj.description) {
          ret = obj.description;
        }
      } else {// Si no son de tipo Master Data
        if (obj['__description']) {
          ret = obj['__description'];
        } else if (obj.contractFolderId) {
          ret = obj.contractFolderId;
          // Woraround para cuando son atributos (nos interesa el ID, nadie conoce la descripcion)
        } else if (obj.attributeNumber) {
          ret = obj.identifier;
        } else if (obj.description) {
          ret = obj.description;
        } else if (obj.desc) {
          ret = obj.desc;
        } else if (obj.person && obj.person.fullName) {
          ret = '[' + obj.identifier + ']' + ' ' + obj.person.fullName;
        } else if (obj.fullName) {
          ret = obj.fullName;
        } else if (obj.name) {
          ret = obj.name;
        } else if (obj.identifier) {
          ret = obj.identifier;
        } else if (obj.toString) {
          ret = obj.toString();
        }
      }
    }
    return ret;
  }

  public formatNumber(): string {
    let stringValue;

    if (this.value || this.value === 0) {
      try {
        if (this.type === 'INTEGER') {
          this.maxDecimals = 0;
        }
        let format = '.' + this.maxDecimals + '-' + this.maxDecimals;
        stringValue = this.decimalService.transform(this.value, format);
      } catch {
        console.log(
          '[' + this.value,
          ']: Error formateando número. Valor actual[',
          this.value,
          ']'
        );
      }
    } else {
      stringValue = '';
    }
    /*
    console.log('TIPO:');
    console.log(this.type);
    console.log('DECIMALES:');
    console.log(this.maxDecimals);
    console.log('VALOR:');
    console.log(this.value);
    console.log('FORMATEADO:');
    console.log(stringValue);
*/
    return stringValue;
  }
}
